import { jsxs as e, jsx as l } from "react/jsx-runtime";
const Z = (a) => /* @__PURE__ */ e("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1rem", height: "1rem", fill: "none", viewBox: "0 0 24 24", ...a, children: [
  /* @__PURE__ */ l(
    "path",
    {
      fill: "#212134",
      fillRule: "evenodd",
      d: "M20.4 14.4a2.4 2.4 0 1 0 0-4.8 2.4 2.4 0 0 0 0 4.8Zm0 1.2a3.6 3.6 0 1 0 0-7.2 3.6 3.6 0 0 0 0 7.2ZM3.6 14.4a2.4 2.4 0 1 0 0-4.8 2.4 2.4 0 0 0 0 4.8Zm0 1.2a3.6 3.6 0 1 0 0-7.2 3.6 3.6 0 0 0 0 7.2ZM20.4 22.8a2.4 2.4 0 1 0 0-4.8 2.4 2.4 0 0 0 0 4.8Zm0 1.2a3.6 3.6 0 1 0 0-7.2 3.6 3.6 0 0 0 0 7.2ZM20.4 6a2.4 2.4 0 1 0 0-4.8 2.4 2.4 0 0 0 0 4.8Zm0 1.2a3.6 3.6 0 1 0 0-7.2 3.6 3.6 0 0 0 0 7.2Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ l("path", { fill: "#212134", d: "M6.24 11.28H18v1.44H6.24v-1.44Z" }),
  /* @__PURE__ */ l(
    "path",
    {
      fill: "#212134",
      fillRule: "evenodd",
      d: "M3.6 22.8a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8Zm0 1.2a3.6 3.6 0 1 1 0-7.2 3.6 3.6 0 0 1 0 7.2ZM3.6 6a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8Zm0 1.2a3.6 3.6 0 1 1 0-7.2 3.6 3.6 0 0 1 0 7.2Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ l(
    "path",
    {
      fill: "#212134",
      d: "M18.328 13.863 6.49 19.765l-.652-1.307 11.838-5.902.652 1.307ZM18.358 10.078 6.398 4.115l-.646 1.294 11.961 5.963.645-1.294Z"
    }
  ),
  /* @__PURE__ */ l(
    "path",
    {
      fill: "#212134",
      d: "M18.323 18.83 6.252 12.813l-.643 1.29 12.071 6.019.643-1.29ZM18.136 5.228 6.207 11.176l-.653-1.311 11.928-5.948.654 1.311Z"
    }
  )
] }), i = Z;
export {
  i as default
};
